export default {
    getAssignedDashboards(state) {
        return state.assignedDashboards;
    },
};
